export { CheckAlt as default } from './CheckAlt';
